import {
  resolvePartialEdgeBlendTargets,
  type PartialEdgeBlendSolidGroup,
  type PartialEdgeBlendTarget,
} from './partial-edge-targets';

type PuppyKernel = ReturnType<typeof import('../../../engine/loader').getPuppyKernel>;

export interface OffsetFaceChamferTargets {
  /** 局部边线解析后的总目标 Shape。 */
  targetShape: unknown;
  /** 所有需要参与等距面倒角的边目标。 */
  edgeTargets: PartialEdgeBlendTarget[];
  /** 兼容旧调用链的边 Shape 列表。 */
  edgeShapes: unknown[];
  /** 按分割 Solid 聚合后的边目标，用于逐实体求解。 */
  solidGroups: PartialEdgeBlendSolidGroup[];
  /** 分割后未参与倒角求解的剩余 Solid。 */
  remainderSolidShapes: unknown[];
  /** 是否需要对部分边线结果执行同域统一。 */
  requiresSameDomainUnification: boolean;
  /** 释放分割过程产生的临时 Puppy CAD 内核 Shape。 */
  cleanup: () => void;
}

/**
 * 解析等距面倒角的局部边线目标。
 *
 * @param input 解析输入。
 * @returns 等距面倒角目标集合。
 */
export function resolveOffsetFaceChamferTargets(input: {
  puppy: PuppyKernel;
  sourceShape: unknown;
  sourceMetadata: Record<string, unknown>;
  definition: ChamferFeatureDefinition;
  sourceObjectId: string;
}): OffsetFaceChamferTargets {
  const targets = resolvePartialEdgeBlendTargets({
    puppy: input.puppy,
    sourceShape: input.sourceShape,
    sourceMetadata: input.sourceMetadata,
    items: input.definition.items,
    partialEdges: input.definition.partialEdgeParametersEnabled === true
      ? input.definition.partialEdges
      : [],
    sourceObjectId: input.sourceObjectId,
    operationLabel: '等距面部分倒角',
  });
  return {
    targetShape: targets.targetShape,
    edgeTargets: targets.edgeTargets,
    edgeShapes: targets.edgeTargets.map(({ edgeShape }) => edgeShape),
    solidGroups: targets.solidGroups,
    remainderSolidShapes: targets.remainderSolidShapes,
    requiresSameDomainUnification: targets.requiresSameDomainUnification,
    cleanup: targets.cleanup,
  };
}
